export const comments_3359080 = {"data":{"data":[],"links":{}}}